import { faSearch } from "@fortawesome/free-solid-svg-icons";
import React, { useContext, useEffect, useState } from "react"
import { ParagraphCustom, InputCustom, ButtonsCustom, TitleCustom } from "../custom";
import { useTranslation } from "react-i18next";
import { LangContext } from "src/hooks/context/lang";
import { RestApiClientContext } from "src/hooks/context/pageContext";
import { Badge, Button, Card, Drawer, Form, Input, notification, Select, Skeleton, Switch, Tag } from "antd";
import { CustomPagination } from "../utils/pagination/pagination";
import { TotalElementsTableList } from "../utils/totalElementsTableList/totalElementsTableList";
import './user.sass';
import { LoadingOutlined } from "@ant-design/icons";
import { API_URL_TEST, URL_IMAGE } from "src/constants/constants";
export interface UserFilter {
    name?: string;
    email?: string;
    state?: number;
    nameUser?: string;
    pagination: {
        Page: number,
        ResultPage: number
    }
}
export interface CurrencyOrder {
    id: string;
    description: string;
    order: number;
}

export interface UserFiltered {
    id: string;
    firstName?: string;
    lastName1?: string;
    lastName2?: string;
    role?: number;
    language?: string;
    currencyOrder?: CurrencyOrder[];
    email?: string;
    phoneNumber?: string;
    registrationDate?: string;
    isActive: boolean;
    userName?: string;
    newPassword?: string;
}
import FileDownload from 'js-file-download';
import { exportExcel } from "../utils/exportExcel/exportExcel";
export default function Users() {
    const { t } = useTranslation("users");
    const [loadingCountries, setLoadingCountries] = useState<boolean>(false);
    const userLangContext = useContext(LangContext);
    const restApiClient = useContext(RestApiClientContext);
    const [availableCountries, setAvailableCountries] = useState<any[]>([]);
    const [guarantiesCurrencies, setGuarantiesCurrencies] = useState<any[]>([]);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [downloadingUsers, setDownloadingUsers] = useState<boolean>(false);
    const [searchTermNameInput, setSearchTermNameInput] = useState<string>("");
    const [searchTermEmailInput, setSearchTermEmailInput] = useState<string>("");
    const [searchTermStateInput, setSearchTermStateInput] = useState<number>(-1);
    const [searchTermNameUserInput, setSearchTermNameUserInput] = useState<string>("");
    const [data, setData] = useState<{ totalRows?: number, usersFiltered?: UserFiltered[] } | null>(null);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [indexUserChoose, setIndexUserChoose] = useState<number>(-1);
    const [pageResults, setPageResults] = useState<any>({ Page: 1, ResultPage: 10 });
    const [form] = Form.useForm();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    const getUsersFiltered = (filter: UserFilter): void => {
        setLoading(true);
        restApiClient.getUsersFiltered(filter)
            .then((data) => {
                setData(data);
            })
            .finally(() => {
                setLoading(false);
            });
    }
    const optionsState = [
        {
            value: -1,
            label: t("options-state.ALL")
        },
        {
            value: 1,
            label: t("options-state.ACT")
        },
        {
            value: 0,
            label: t("options-state.INA")
        }
    ];
    function searchCriteria() {
        const filter: UserFilter = {
            name: searchTermNameInput,
            email: searchTermEmailInput,
            state: searchTermStateInput,
            nameUser: searchTermNameUserInput,
            pagination: pageResults
        }
        getUsersFiltered(filter)
    }

    const getAvailableCountries = async (): Promise<void> => {
        setLoadingCountries(true);
        await restApiClient.GetAgentLanguagesForUsers().then((r: any) => {
            setAvailableCountries(r.map((country) => ({ id: country.id, label: country.name })));
        })
        setLoadingCountries(false);
    }
    const getGuarantiesCurrencies = async (): Promise<void> => {
        await restApiClient.GetGuarantiesCurrencies().then((r: any) => {
            setGuarantiesCurrencies(r);
        })
    }

    useEffect(() => {
        function handleResize() {
            setIsMobile(window.innerWidth < 768);
        }

        window.addEventListener('resize', handleResize);

        // Limpieza al desmontar
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    useEffect(() => {

        getAvailableCountries()
    }, [userLangContext.GetLangContext()]);

    function handleOnFinish(values) {
        values.currencyOrder = values.currencyOrder.map((currency: string, index) => ({ id: currency, description: currency, order: index }));
        if (indexUserChoose === -1) {
            restApiClient.createUser(values).then((res) => setData(prevData => ({ ...prevData, usersFiltered: [...prevData.usersFiltered, res] }))).catch(() => {
                // Si da error el fetech, volvemos a cargar los datos
                setData(prevData => ({ ...prevData, usersFiltered: prevData.usersFiltered.filter(user => user.newPassword !== values.newPassword) }))
            })
        } else {
            const dataRefresh = [...data.usersFiltered]
            dataRefresh[indexUserChoose] = { ...values, id: dataRefresh[indexUserChoose].id };
            dataRefresh[indexUserChoose].registrationDate = data.usersFiltered[indexUserChoose].registrationDate;
            setData(prevData => ({
                ...prevData, usersFiltered: dataRefresh
            }))
            restApiClient.updateUser(values, data.usersFiltered[indexUserChoose].id).catch(() => {
                setData(prevData => ({ ...prevData, usersFiltered: [...data.usersFiltered] }))
            }).finally(() => {
                setOpenDrawer(false);
            });
        }
        setOpenDrawer(false);
    }

    const sendExcel = async () => {
        try {
            setDownloadingUsers(true);

            const filter = {
                language: userLangContext.GetLangContext(),
                Name: searchTermNameInput,
                Email: searchTermEmailInput,
                Status: searchTermStateInput,
                UserName: searchTermNameUserInput,
            };

            const response = await exportExcel(`${API_URL_TEST}/Users/exportexcel`, filter);

            if (response.isFile) {
                FileDownload(response.data, t("users:excel-name-file") + '.xlsx');
            } else {
                console.log(response.data);



                notification.error({
                    message: t("Error"),
                    description: response.data?.message || "Error al generar el Excel",
                })


            }

        } catch (error) {
            console.error(error);
            alert("Error inesperado");
        } finally {
            setDownloadingUsers(false);
        }
    };
    useEffect(() => {
        setLoading(true);
        getGuarantiesCurrencies().then(() => {
            getAvailableCountries().then(() => {
                searchCriteria();
            });
        });



    }, [pageResults])


    return <>
        <div className="col-12">
            <TitleCustom
                level={1}
                class="title-section"
                text={t("title")}
            />
            <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                <ParagraphCustom
                    class={"p-0"}
                    text={t("subtitle")}
                />
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <ButtonsCustom
                        id="btn-excel"
                        class={"button-agent-register"}
                        onClick={sendExcel}
                        content={
                            <div className="button-excel">
                                {downloadingUsers ? <LoadingOutlined /> : <img src={URL_IMAGE + "excel-logo.svg"} />}
                                <ParagraphCustom
                                    class={"mb-0 ml-1"}
                                    text={<>{t("title")}</>}

                                />
                            </div>
                        }
                    />
                    <ButtonsCustom
                        id="btn-retribution"
                        className="btn-primary"
                        type="primary"
                        class="button-agent-register-movil"

                        htmlType={null}
                        onClick={() => {
                            setOpenDrawer(true)
                            form.resetFields();
                            setIndexUserChoose(-1);
                        }}

                        content={
                            <span>
                                <strong>{t("add-user")}</strong>
                            </span>
                        }
                    />

                </div>

            </div>

        </div>
        <div id="filters">
            <div className="col-12 mt-3">
                <div className="row pr-3 pl-3 form-search-agency">
                    <div className="col-xs-12 col-lg-5 label-left-search-lg">
                        <ParagraphCustom text={<strong>{t("name-lastname")}</strong>} />
                        <InputCustom
                            id={"name"}
                            value={searchTermNameInput}
                            placeholder=""
                            className="main-input"
                            prefix={false}
                            allowClear={true}
                            classIcon={"search-agency-icon-input"}
                            icon={faSearch}
                            autoFocus={true}
                            onChange={(e) => setSearchTermNameInput(e.target.value)}
                        />
                    </div>
                    <div className="col-xs-12 col-lg-4 col-md-6 label-left-search label-right-search">
                        <ParagraphCustom text={<strong>{t("email")}</strong>} />
                        <InputCustom
                            id={"email"}
                            value={searchTermEmailInput}
                            placeholder=""
                            className="main-input"
                            classIcon={"search-agency-icon-input"}
                            prefix={false}
                            allowClear={true}
                            icon={faSearch}
                            onChange={e => setSearchTermEmailInput(e.target.value)}
                        />
                    </div>
                    <div className="col-xs-12 col-lg-3 col-md-6 label-right-search">
                        <ParagraphCustom text={<strong>{t("state")}</strong>} />
                        <Select
                            id="state"
                            className="col-12 main-input"
                            options={optionsState}
                            value={searchTermStateInput}
                            onChange={e => setSearchTermStateInput(e)}
                        />
                    </div>
                    <div style={{ paddingRight: '0' }} className="col-xs-12 col-lg-9 label-left-search-lg">
                        <ParagraphCustom text={<strong>{t("name-user")}</strong>} />
                        <InputCustom
                            value={searchTermNameUserInput}
                            id={"name-user"}
                            placeholder=""
                            className="main-input"
                            classIcon={"search-agency-icon-input"}
                            prefix={false}
                            allowClear={true}
                            icon={faSearch}
                            onChange={e => setSearchTermNameUserInput(e.target.value)}
                        />
                    </div>
                    <div className="col-xs-12 col-lg-3 label-right-search button-search">
                        <ButtonsCustom
                            id="search-agency"
                            class={"primary-button col-12"}
                            type=""
                            htmlType={null}
                            onClick={searchCriteria}
                            size={null}
                            content={
                                <span>
                                    <strong>{t("search-button")}</strong>
                                </span>
                            }
                        />
                    </div>

                </div>
            </div>
        </div>
        <Skeleton loading={isLoading} active>

            {data?.usersFiltered && <div className="container-users col-12 pr-3 pl-3 ">
                {data.usersFiltered.map((user, index) => <>
                    <Badge.Ribbon text={user.isActive ? t('user-active') : t('user-inactive')} color={user.isActive ? 'green' : 'red'}>
                        <Card
                            style={{ borderRadius: '5px' }}
                            key={user.id}
                            onClick={() => {
                                setOpenDrawer(true)
                                setIndexUserChoose(index)
                                form.setFieldsValue({
                                    firstName: user?.firstName,
                                    lastName1: user?.lastName1 || '',
                                    lastName2: user?.lastName2 || '',
                                    role: user?.role || 2,
                                    email: user?.email,
                                    phoneNumber: user?.phoneNumber || null,
                                    language: user?.language,
                                    isActive: user?.isActive,
                                    id: user?.id,
                                    userName: user?.userName,
                                    currencyOrder: user?.currencyOrder.sort((a, b) => a.order - b.order).map(x => x.id) || [],
                                    registrationDate: user?.registrationDate,
                                    newPassword: user?.newPassword || '',
                                    confirmPassword: ''


                                })
                            }}
                            bordered
                            hoverable
                            title={<p className="text"><strong>{user.userName}</strong></p>}>

                            <div className="card-content">
                                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'start' }}>
                                    <div>
                                        <p className="text">{t('name')}</p>
                                        <p style={{ width: '100%' }} className="text"><strong>{user.firstName}</strong></p></div>
                                    <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                                        <p className="text">{availableCountries ? availableCountries.find(x => x.id.split('-')[1] === user.language.split('-')[1])?.label : `${t('loading')}...`}</p>
                                        <img style={{ maxWidth: "16px", height: 'fit-content' }} src={`https://flagsapi.com/${user.language.split('-')[1]}/flat/24.png`} />
                                    </div>
                                </div>

                                <div className={isMobile ? "col-12" : "col-5"} style={{ padding: '0' }}>
                                    <p className="text">{t('last-name')}</p>
                                    <p className="text"><strong>{user.lastName1 + ' ' + user.lastName2}</strong></p>
                                </div>

                                <div className={isMobile ? "col-12" : "col-7"} style={{ padding: '0' }}>
                                    <p className="text">{t('email')}</p>
                                    <p className="text"><strong>{user.email}</strong></p>
                                </div>

                                <div className={isMobile ? "col-12" : "col-6"} style={{ padding: '0' }}>
                                    <p className="text">{t('phone')}</p>
                                    <p className="text"><strong>{user?.phoneNumber && !user?.phoneNumber.includes(" ") ? user?.phoneNumber : t('no-phone-number')}</strong></p>
                                </div>

                                <div className={isMobile ? "col-12" : "col-5"} style={{ padding: '0' }}>
                                    <p className="text">{t('register-date')}</p>
                                    <p className="text"><strong>{user.registrationDate ? new Date(user.registrationDate).toLocaleDateString() : ''}</strong></p>
                                </div>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px', marginTop: '10px', width: '100%' }} className="col-12 p-0">
                                    {user?.currencyOrder && user?.currencyOrder.length > 0 ?
                                        user.currencyOrder.sort((a, b) => a.order - b.order).map((currency) =>
                                            <Tag style={{ height: 'fit-content' }} key={currency.id + user.id} color="default">{currency.id}</Tag>
                                        ) : null}
                                </div>
                            </div>

                        </Card>
                    </Badge.Ribbon>

                </>
                )}
            </div>}

        </Skeleton>
        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', marginTop: '20px' }} className="col-12 p-0">
            <div style={{ marginBottom: '30px' }} className="p-0">
                <TotalElementsTableList total={data?.totalRows || 0} />
            </div>
            <div style={{ width: 'fit-content' }} className="p-0 pagination-container">
                <CustomPagination
                    setPageResults={setPageResults}
                    pageResults={pageResults}
                    countData={data?.totalRows || 0}
                    onChangeCallApi={(pagination) => setPageResults(pagination)}
                />
            </div>
        </div>
        <Drawer visible={openDrawer} closable onClose={() => setOpenDrawer(false)} >

            <Form
                form={form}
                layout="vertical"

                onFinish={handleOnFinish}
            >

                <Form.Item label={t('name')} name="firstName" rules={[{ required: true, message: t('required') }]}>
                    <Input />
                </Form.Item>

                <Form.Item label={t('last-name1')} name="lastName1" rules={[{ required: true, message: t('required') }]}>
                    <Input />
                </Form.Item>
                <Form.Item label={t('last-name2')} name="lastName2" >
                    <Input />
                </Form.Item>

                <Form.Item label={t('email')} name="email" rules={[{ required: true, type: 'email', message: t('invalid-email') }]}>
                    <Input />
                </Form.Item>
                <Form.Item label={t('name-user')} name="userName" rules={[{ required: true, message: t('required') }]}>
                    <Input />
                </Form.Item>
                <Form.Item label={indexUserChoose === -1 ? t('password') : t('new-password')} name="newPassword" rules={[{ required: indexUserChoose == -1, message: t('required') }]}>
                    <Input.Password />
                </Form.Item>
                <Form.Item label={t('confirm-password')} name="confirmPassword"
                    dependencies={['newPassword']}
                    hasFeedback
                    rules={[
                        { required: indexUserChoose == -1, message: t('required') },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                const newPassword = getFieldValue('newPassword');
                                // Solo validar si newPassword tiene valor
                                if (!newPassword || !value) {
                                    return Promise.resolve(); // no hay error si alguno está vacío
                                }
                                if (newPassword === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error(t('passwords-do-not-match')));
                            },
                        }),
                    ]}>
                    <Input.Password />
                </Form.Item>
                <Form.Item rules={[{ required: true, message: t('required') }]} label={t('role')} name="role">
                    <Select disabled={loadingCountries}>
                        <Select.Option value={1}>{t('role-admin')}</Select.Option>
                        <Select.Option value={2}>{t('role-user')}</Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item label={t('phone')} name="phoneNumber">
                    <Input />
                </Form.Item>

                <Form.Item rules={[{ required: true, message: t('required') }]} label={t('language')} name="language">
                    <Select disabled={loadingCountries}>
                        {availableCountries ? availableCountries.map((country) => <Select.Option value={country.id}>{country?.label}</Select.Option>) : null}
                    </Select>
                </Form.Item>

                <Form.Item className="margin-bottom-zero"
                    label={t('currency-order')}
                    name="currencyOrder"
                    rules={[{ required: true, message: t('required') }]}
                >
                    <Select
                        mode="multiple"
                        placeholder={t('select-currencies')}
                        optionLabelProp="label"
                    >
                        {guarantiesCurrencies.map((currency) => (
                            <Select.Option
                                key={currency}
                                value={currency}
                                label={currency}
                            >
                                {currency}
                            </Select.Option>
                        ))}
                    </Select>

                </Form.Item>
                <small style={{ display: "block", color: "#cfcfcf" }}>
                    {t("currency-order-description")}
                </small>
                <div style={{ marginTop: "24px" }}>
                    <Form.Item label={t('active')} name="isActive" valuePropName="checked">
                        <Switch />
                    </Form.Item>
                </div>

                <Form.Item style={{ display: 'flex', justifyContent: 'end' }}>

                    <Button style={{ width: '100%' }} type="primary" htmlType="submit" loading={isLoading}>
                        {t('save')}
                    </Button>


                </Form.Item>
            </Form>
        </Drawer>
    </>
}